export class AssignHelper {
    static assignPickupMinutes: number = 5;
    static assignPickupHours: number = 0;
    static assignDeliveryMinutes: number = 5;
    static assignDeliveryHours: number = 0;
}